export default {
    add_to_egisz: "ЕГИСЗ қосу",
    comment_to_deal: "Мәмілелерге түсіндірме",
    diagnosis_comments: "Диагнозға түсіндірме",
    download_all: "Барлығын жүктеу",
    edit_patient: "Науқасты өңдеу",
    egisz: "ЕГИСЗ",
    for_rework: "Пысықтауға",
    funnel: "Қайталама",
    go_to_egisz_page: "Денсаулық сақтаудың бірыңғай мемлекеттік ақпараттық жүйесі бетіне өтіңіз",
    list: "Тізім",
    main_doctor: "Бас дәрігер",
    patient_rejected_to_send_to_egisz: "Пациент деректерді ЕГИСЗ жіберуден бас тартты",
    prepare_document_for_sending_to_egisz: "Құжатты ЕГИСЗ жіберуге дайындау керек пе?",
    processing_status: "Өңдеу  статусы",
    representative_relation: "Пациенттің өкілі кім",
    requires_attention: "Назар аударуды қажет етеді",
    send_all: "Барлығын жіберу",
    send_to_egisz: "ЕГИСЗ жіберу",
    sent_to_egisz: "ЕГИСЗ жіберу",
    show_more: "Толығырақ",
    show_only_not_sent: "Тек жіберілмегендерді көрсету",
    sign: "Қол қою",
    sign_all: "Барлығына қол қою",
    signed_by_doctor: "Дәрігермен қол қойылды",
    signed_by_main_doctor: "Бас дәрігермен қол қойылды",
    to_egisz_page: "ЕГИСЗ парақшасына",
    to_rework: "Пысықтауға",
    to_sign: "Қол қоюға"
}
